// ZM - Reviewed by Claude Portal-Review Deep Dive 2026-05-05

import React from 'react';
import classNames from 'classnames';
import css from './ScrollBar.module.scss';


// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface IProps {
    scrollVertical?: boolean;
    scrollHorizontal?: boolean;
    theme?: string;
    colorSensitiveEnabled?: boolean;
}

const ScrollBar = (props) => {
    let themeColor = getComputedStyle(document.documentElement).getPropertyValue('--scrollbarThumb');
    if (props.theme === 'lexus' || props.theme === 'lexusMonogram') {
        themeColor = getComputedStyle(document.documentElement).getPropertyValue('--textColor');
    }
    // Parse light-dark() CSS function to get a single color value
    themeColor = parseColorValue(themeColor, props.colorSensitiveEnabled);
    updateScrollbarColor(themeColor, props.theme, props.colorSensitiveEnabled);

    const className = classNames(
        css.scrollBar,
        {
            [css.horizontal]: props.scrollHorizontal,
            [css.vertical]: props.scrollVertical,
        },
    );

    return (
        <div className={className} key={props.theme}>
            {props.children}
        </div>
    );
};

export default ScrollBar;

// #region Functions
/**
 * Parses a CSS color value that may contain light-dark() function
 * Returns the appropriate color based on colorSensitiveEnabled flag
 * @param colorValue - The CSS color value (may be light-dark(lightColor, darkColor) or a plain color)
 * @param colorSensitiveEnabled - If true, returns dark color; if false, returns light color
 * @returns A single valid color value
 */
function parseColorValue(colorValue: string, colorSensitiveEnabled?: boolean): string {
    const trimmedValue = colorValue.trim();

    // Check if the value contains light-dark() function
    const lightDarkMatch = trimmedValue.match(/light-dark\((.*?),\s*(.*?)\)/);

    if (lightDarkMatch) {
        // Extract light color (first parameter) and dark color (second parameter)
        const lightColor = lightDarkMatch[1].trim();
        const darkColor = lightDarkMatch[2].trim();

        // Return dark color if colorSensitiveEnabled is true, otherwise light color
        return colorSensitiveEnabled ? darkColor : lightColor;
    }

    // If no light-dark() function found, return the value as-is
    return trimmedValue;
}

// The generateArrow functions allows us to change the color of the button, which CSS can not do to an external SVG
function generateLeftArrowSVG(color: string) {
    const leftArrowSVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="` + color +
    `" width="30" height="20"><path d="M8 12L14 6V18L8 12Z"></path></svg>`;

    return `url('data:image/svg+xml;utf8,${encodeURIComponent(leftArrowSVG)}')`;
}

function generateRightArrowSVG(color: string) {
    const rightArrowSVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="` + color +
    `" width="30" height="20"><path d="M16 12L10 18V6L16 12Z"></path></svg>`;

    return `url('data:image/svg+xml;utf8,${encodeURIComponent(rightArrowSVG)}')`;
}

function updateScrollbarColor(themeColor: string, theme: string, colorSensitiveEnabled?: boolean) {
    const leftEncodedSVG = generateLeftArrowSVG(themeColor);
    const rightEncodedSVG = generateRightArrowSVG(themeColor);
    let dividerColor = getComputedStyle(document.documentElement).getPropertyValue('--dividerColor');
    // Parse light-dark() CSS function to get a single color value
    dividerColor = parseColorValue(dividerColor, colorSensitiveEnabled);
    let adabackground = getComputedStyle(document.documentElement).getPropertyValue('--backgroundcolor');
    // Parse light-dark() CSS function to get a single color value
    adabackground = parseColorValue(adabackground, colorSensitiveEnabled);

    const styleSheet = document.createElement('style');
    styleSheet.type = 'text/css';
    if (theme === 'colorSensitive' || colorSensitiveEnabled) {
        styleSheet.innerText = `
        ::-webkit-scrollbar-track:horizontal {
            background-color: ${adabackground};
        }
        ::-webkit-scrollbar-button:horizontal:increment {
            background-image: ${rightEncodedSVG};
            background-color: ${adabackground};
        }

        ::-webkit-scrollbar-button:horizontal:decrement {
            background-image: ${leftEncodedSVG};
            background-color: ${adabackground};
        }
    `;
    } else {
        styleSheet.innerText = `
        ::-webkit-scrollbar-track:horizontal {
            background-color: ${dividerColor};
        }
        ::-webkit-scrollbar-button:horizontal:increment {
            background-image: ${rightEncodedSVG};
            background-color: ${dividerColor};
        }

        ::-webkit-scrollbar-button:horizontal:decrement {
            background-image: ${leftEncodedSVG};
            background-color: ${dividerColor};
        }
    `;
    }

    document.head.appendChild(styleSheet);
}
// #endregion